import { CheckPardakhtBeforSave } from '../adapaters/CheckPardakhtBeforSave';

export const HandleOperatePaymentPortal = (
  portal,
  data
) => {
  console.log('HandleOperatePaymentPortal ===+>', data);

  CheckPardakhtBeforSave({ portal, ...data });
};
